<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="listQuery.keyword_search" clearable style="width: 200px" class="name-input" placeholder="输入分类名称搜索" />
            </el-form-item>

            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
                <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="showDialog('add')">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center">
            <el-table-column prop="sort" label="排列序号" align="center" />
            <el-table-column prop="name" label="分类名称" align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="showDialog('edit',scope)">编辑</el-button>
                    <el-button v-if="hasDelete" type="danger" size="mini" class="op_buttton" @click="showDialog('delete',scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>

        <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns" dialog-width="32%">
            <el-form :model="classInfo" class="dialog_wrap">
                <el-form-item label="分类名称" label-width="80px">
                    <el-input v-model="classInfo.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>

                <el-form-item label="排列序号" label-width="80px">
                    <el-input-number v-model="classInfo.sort" :min="1" clearable placeholder="请输入分类排序" style="width:300px"></el-input-number>
                </el-form-item>

                <el-form-item class="button_wrap">
                    <el-button @click="dialogVisible=false">返回</el-button>
                    <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
                </el-form-item>
            </el-form>
        </common-dialog>

    </div>
</template>
<script>
import { getArticleClass, addArticleClass, deleteArticleClass, editArticleClass } from '@/api/college.js';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';

export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10,
                keyword_search: ""
            },
            classInfo: {
                name: "",
                sort: ""
            },
            id: "",
            listLoading: false
        };
    },
    computed: {
        hasAdd() {
            return this.operations.includes('新建标签分类');
        },
        hasEdit() {
            return this.operations.includes('编辑标签分类');
        },
        hasDelete() {
            return this.operations.includes('删除标签分类');
        }
    },
    async mounted() {
        this.getList();
    },

    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getArticleClass(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        showDialog(value, scope) {
            if (value == "delete") {
                this.$confirm(`是否删除该分类？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    const res = await deleteArticleClass(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '删除分类成功', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else {
                if (value == "edit") {
                    this.dialogTitle = "编辑分类"
                    this.id = scope.row.id;
                    this.classInfo = Object.assign({}, scope.row)
                } else if (value == "add") {
                    this.classInfo = {
                        name: "",
                        sort: ""
                    }
                    this.dialogTitle = "新建分类"
                }
                this.dialogType = value;
                this.dialogVisible = true
            }
        },

        async dialogConfirmClick() {
            const { name, sort } = this.classInfo;
            if (!name) return this.$notify.error({ title: '请输入分类名称' });
            if (!sort) return this.$notify.error({ title: '请输入分类排序' });
            if (this.dialogType == "edit") {
                const res = await editArticleClass(this.id, this.classInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '分类编辑成功', type: 'success' });
                    this.dialogVisible = false
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            } else if (this.dialogType == "add") {
                const res = await addArticleClass(this.classInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '新增分类成功', type: 'success' });
                    this.dialogVisible = false
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 80px;
        }
        /deep/ .dialog_wrap {
            .el-input{
                width: 300px;
            }
        }
    }
</style>
